import type { Theme } from '@mui/material/styles';

import { stepIconClasses } from '@mui/material/StepIcon';

import { onSurface } from '../../onSurface';

// ----------------------------------------------------------------------

export function stepper(theme: Theme) {
  return {
    // A completed step is a check drawn straight on the surface, so it is the
    // brand as a MARK, not a fill — `primary.main` (MUI's default) is 1.57:1 on
    // a cream tenant. The ACTIVE step stays `primary.main`: it is a filled disc
    // carrying its number in `primary.contrastText`.
    MuiStepIcon: {
      styleOverrides: {
        root: {
          [`&.${stepIconClasses.completed}`]: {
            color: onSurface.primary,
          },
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
  };
}
